export default __webpack_public_path__ + "static/elimination-featured-image-3a78444ba8a348bf308a8af92c9004ac.webp";